import xssFilters from 'xss-filters';

const VARS = {
  __AUTH0_USERNAME__: (data) => data.account.userName,
  __AUTH0_APPNAME__: (data) => data.account.appName,
  __AUTH0_TENANT__: (data) => data.account.tenant,
  __AUTH0_NAMESPACE__: (data) => data.account.namespace,
  __AUTH0_CLIENT_ID__: (data) => data.account.clientId,
  __AUTH0_CLIENT_SECRET__: (data) => data.account.clientSecret,
  __AUTH0_CALLBACK__: (data) => data.account.callback,
  __AUTH0_CONNECTION_NAME__: (data) => data.connectionName,
  __AUTH0_API_IDENTIFIER__: (data) => data.apiIdentifier,
  // modify manage urls with # sign to match new urls
  'https://__AUTH0_MANAGE_URL__/#': (data) => data.manage_url,
  // modify manage urls without # sign
  'https://__AUTH0_MANAGE_URL__': (data) => data.manage_url,
};

/**
 * This replaces placeholders in document content with the actual values
 * for the current user.
 */
export default function replaceUserVars(html, context) {
  let transformed = html;

  Object.keys(VARS).forEach((key) => {
    const value = xssFilters.inHTMLData(VARS[key](context));
    // eslint-disable-next-line security/detect-non-literal-regexp
    transformed = transformed.replace(new RegExp(key, 'g'), value);
  });

  return transformed;
}
